import React, { useEffect, useState } from 'react';

import * as S from './styles';
import document from '../../../assets/icons/document.svg';
import api from '../../../services/api';

import { isTotvs } from "../../../services/globalFunctions";
import ModalAlertTotvs from '../../../components/modal/modalAlertTotvs';

import { H5, TaglineM } from '../../../styles/stylesTypography';
import { theme } from '../../../styles/theme';

export const compendioG = "@compendioG";

const Recipe = ({ maxWidth, ...props }) => {
    const [showModalTotvs, setShowModalTotvs] = useState(false);

    return (
        <>
            <S.Container>
                <S.Header maxWidth={maxWidth}>
                    <H5 color={theme.colors.white.Branco}>Emita seu primeiro Receituário agora mesmo</H5>

                    <S.ButtonHeader onClick={() =>{
                        if (isTotvs()) {
                            setShowModalTotvs(true);
                        } else {
                            window.location = '/receitas/add';
                        }
                    }}>
                        <img src={document} alt="" />

                        <TaglineM 
                        color={theme.colors.white.Branco} 
                        fontWeight={800}
                        >EMITIR NOVA RECEITA</TaglineM>
                    </S.ButtonHeader>
                </S.Header>
            </S.Container>

            <ModalAlertTotvs
                    show={showModalTotvs}
                    marginBottom="0"
                    onHide={() => setShowModalTotvs(false)}
                    />
        </>
    );
};

export default Recipe;